module.exports = __webpack_public_path__ + "static/doors_night-ed103e55552e1e642c763e0ccf0d6e25.jpg";